<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img src="../../assets/img_h5/news/block_1.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Events & News</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div v-if="infoData" class="block_1_main">
					<div class="title"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>{{ infoData.title }}</div>
					<div class="time"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>Release Date:&ensp;{{ initTime(infoData.fabu_time) }}</div>
					<div v-if="infoData.content" class="content_box" v-html="infoData.content"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					></div>
					<div class="btn_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<van-button color="#006BB3" class="btn_el" @click="goContact">Contact Us</van-button>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import contact from '@/component/h5/contact.vue'  //联系我们组件
import { UPURL } from '@/util/util.js';
import { articleDetail } from '@/api/public.js';
import moment from 'moment';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		if(that.$route.params.newsId) {
			articleDetail({ custom: that.$route.params.newsId }).then(res => {
				that.infoData = res.data;
				document.title = that.infoData.title + ' - Jtests | IVD Active Materials';
				that.isLoading = false;
			});
		}else {
			that.$toast('Parameter exception, failed to obtain details.');
		}
	},
	methods: {
		goContact() {
			this.$router.push('/contact');
		},
		initTime(value) {
			return moment(value * 1000).format('MM-DD-YYYY');
		},
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		padding: 50px 20px 25px 20px;
		.block_1_main{
			width: 100%;
			.btn_box{
				padding: 0px 0 20px 0;
				text-align: center;
				.btn_el{
					padding: 5px 40px 0 40px;
					font-size: 18px;
					border-radius: 6px;
				}
			}
			.content_box{
				padding: 20px 0;
			}
			.time{
				padding-top: 20px;
				color: #808080;
				font-size: 16px;
				text-align: center;
			}
			.title{
				font-size: 32px;
				text-align: center;
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 0 20px;
			text-align: center;
			.txt{
				font-size: 18px;
				color: #ffffff;
			}
			.tit{
				font-size: 36px;
				color: #ffffff;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box img{
	max-width: 100%;
	height: auto;
}
>>> .main_box th{
	padding: 12px;
	background-color: #9F58AE;
	color: #ffffff;
}
>>> .main_box td, >>> .main_box th {
	border: 1px solid #CCCCCC;
	font-size: 16px;
}
>>> .main_box table {
	max-width: 100%;
	border-collapse: collapse;
}
</style>